import { motion } from 'framer-motion';
import { Answer, CreateAnswerDto } from '@/types/workerInfo.types';
import { CategoryHeader } from '../common/CategoryHeader';
import { TextInput } from '../inputs/TextInput';
import { SingleChoiceInput } from '../inputs/SingleChoiceInput';
import { MultipleChoiceInput } from '../inputs/MultipleChoiceInput';
import { DocumentInput } from '../inputs/DocumentInput';
import { colors, spacing } from '@/theme';

interface DocumentationCategoryProps {
  answers: Answer[];
  progress: number;
  onUpdateAnswer: (questionId: string, data: Partial<CreateAnswerDto>) => Promise<void>;
  saving: boolean;
}

export function DocumentationCategory({
  answers,
  progress,
  onUpdateAnswer,
  saving,
}: DocumentationCategoryProps) {
  const renderInput = (answer: Answer) => {
    const { questionId } = answer;
    const commonProps = {
      key: questionId,
      answer,
      onBlur: async (value: any) => {
        try {
          await onUpdateAnswer(questionId, value);
        } catch (error) {
          console.error('Error updating:', error);
        }
      },
      disabled: saving,
    };

    switch (answer.question.type) {
      case 'document':
        return <DocumentInput {...commonProps} />;
      case 'single_choice':
        return <SingleChoiceInput {...commonProps} options={answer.question.options || []} />;
      case 'multiple_choice':
        return <MultipleChoiceInput {...commonProps} options={answer.question.options || []} />;
      case 'text':
      default:
        return <TextInput {...commonProps} />;
    }
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.25 }}>
      <CategoryHeader
        icon="📄"
        title="Documentacion"
        description="Sube y completa los documentos requeridos por el proceso."
        progress={progress}
      />

      <div style={{ display: 'flex', flexDirection: 'column', gap: spacing[3] }}>
        {answers.map((answer, index) => (
          <motion.div
            key={answer.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.03 }}
            style={{
              padding: spacing[4],
              borderRadius: 16,
              border: `1px solid ${colors.gray[100]}`,
              backgroundColor: colors.white,
            }}
          >
            {renderInput(answer)}
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}
